export const reservasModals = {
  roomChange: {
    close: "Fechar",
    titleAssign: "Atribuir quarto",
    titleChange: "Alterar quarto",
    stopSoldNote:
      "Este tipo de quarto está fechado para venda nessas datas (stop-sell), mas você ainda pode reorganizar os quartos: mover ou atribuir não reabrirá as vendas.",
    labelAssign: "Quarto a atribuir",
    labelNew: "Novo quarto",
    selectPlaceholder: "Selecione um quarto…",
    swapWith: "Trocar com {names}",
    swapWithType: "Trocar com {names} (passa para {type})",
    swapTypeWarning: "Ao trocar, {names} passa para {type}, que não é o tipo que reservou.",
    swapGroup:
      "Troca em grupo: {name} e {also} vão para esse quarto, e {incoming} vêm para o seu. Tudo em uma única operação.",
    swapSingle:
      "Esse quarto está ocupado por {names}. Ao salvar, eles serão {action}: sua reserva vai para esse quarto e a(s) outra(s) vem para o seu.",
    swapWord: "trocados",
    emptyNote:
      "Nenhum quarto está livre durante todo o intervalo. Use o botão {action} na faixa «A organizar» para reorganizar as reservas automaticamente.",
    organizeWord: "Organizar",
    sameTypeGroup: "Mesmo tipo · {name}",
    otherTypeGroup: "Outro tipo · {name}",
    typeChangeNote:
      "A reserva passará para {type}. A ficha é atualizada, a disponibilidade dos dois tipos é recalculada e os canais são avisados.",
    selectRoomError: "Você precisa selecionar um quarto",
    cancel: "Cancelar",
    confirmSwap: "Trocar",
    confirmAssign: "Atribuir",
    confirmSave: "Salvar alteração",
  },
  outOfOrder: {
    titleMaintenance: "Manutenção do quarto",
    titleActions: "Ações do tipo de quarto",
    scopeLabel: "Escopo",
    scopeUnit: "Tipo de quarto (todos)",
    scopeInstance: "Este quarto",
    actionLabel: "Ação",
    actionOoo: "Fora de operação (manutenção)",
    actionOpen: "Reabrir no intervalo",
    quantityLabel: "Número de quartos",
    maxPerDay: "Até {max} por dia.",
    dateRangeLabel: "Intervalo de datas",
    from: "De",
    to: "Até",
    cancel: "Cancelar",
    apply: "Aplicar",
  },
  closeDay: {
    title: "Alterar disponibilidade",
    syncing: "Sincronizando disponibilidade...",
    roomTypeLabel: "Tipo de quarto",
    roomTypePlaceholder: "Selecione um quarto",
    startDate: "Data de início",
    endDate: "Data de término",
    maxAvailable: "Máximo: {count} disponíveis",
    cancel: "Cancelar",
    apply: "Aplicar alteração",
  },
  confirm: {
    defaultTitle: "Confirmar?",
    confirm: "Confirmar",
    cancel: "Cancelar",
  },
  updateAlert: {
    title: "Atualizar quarto",
    sectionTitle: "Informações do quarto",
    nameLabel: "Nome ou número do quarto",
    keyLabel: "Chave de acesso",
    cancel: "Cancelar",
    submit: "Atualizar quarto",
    nameRequired: "O nome ou número do quarto é obrigatório",
  },
};
